module.exports = __webpack_public_path__ + "static/p07_sombraBorreguitoR-022fc9d55d294dfdae96f900f0653805.png";